export default (state, action) => {
  const merged = {
    ...state,
    ...action.payload
  };

  switch (action.type) {
    case 'UPDATE_MODEL_PROPERTY':
      console.log('UPDATE_MODEL_PROPERTY');
      console.log(merged);

      return {
        ...merged
      }

    default:
      throw new Error('UNREGISTERED ACTION!');
  }
}
